import pjson from "../../package.json";

export const ver = pjson.version;
export const nameProject = pjson.name;

export const { ambiente } = window["runConfig"];
export const { URL_BASE } = window["runConfig"];


export const URL_LOGIN = `${URL_BASE}/api/auth/login`;
export const URL_BASE_VER = `${URL_BASE}/api/Ver`;
export const URL_BASE_ACCESOPROVEEDORES = `${URL_BASE}/api/AccesoProveedores`;
export const URL_GENERICOS = `${URL_BASE}/api/genericos`;
export const URL_SELFSERVICE_SERVICIOS = `${URL_BASE}/api/SelfServiceServicios`;
export const URL_SELFSERVICE_OP = `${URL_BASE}/api/SelfServiceOp`;
export const URL_SELFSERVICE_OP_FILES = `${URL_BASE}/api/SelfServiceOpFiles`;





export const { HDI_URL } =  window['runConfig']

// URLs para Sistema de Solicitudes de Atención a Proveedores
export const URL_SOLICITUDES_PROVEEDORES = `${URL_BASE}/api/ProveedoresSolicitudes`;
export const URL_ATENCION_SOLICITUDES = `${URL_BASE}/api/AtencionSolicitudesProveedores`;

// Endpoints actualizados según API real validada
export const URL_GET_SOLICITUDES_POR_USUARIO = `${URL_SOLICITUDES_PROVEEDORES}/GetSolicitudesPorUsuarioID`;
export const URL_NUEVA_SOLICITUD = `${URL_SOLICITUDES_PROVEEDORES}/NuevaSolicitud`;
export const URL_NUEVO_COMENTARIO = `${URL_SOLICITUDES_PROVEEDORES}/NuevoComentarioSolicitudHistorial`;
export const URL_LISTA_COMENTARIOS = `${URL_SOLICITUDES_PROVEEDORES}/GetListaComentariosPorSolicitudID`;
export const URL_CERRAR_SOLICITUD = `${URL_SOLICITUDES_PROVEEDORES}/CerrarProveedorSolicitud`;
export const URL_CONFIRMAR_LECTURA = `${URL_SOLICITUDES_PROVEEDORES}/ConfirmarLecturaComentario`;

// Endpoints para archivos en solicitudes
export const URL_GET_LISTA_PROVEEDORES_SOLICITUDES = `${URL_SOLICITUDES_PROVEEDORES}/GetListaProveedoresSolicitudes`;
export const URL_CARGAR_DOCUMENTO_SOLICITUD = `${URL_SOLICITUDES_PROVEEDORES}/CargaDocumentoSolicitud`;
export const URL_LISTA_ARCHIVOS_POR_SOLICITUD = `${URL_SOLICITUDES_PROVEEDORES}/ListaArchivosPorSolicitudID`;
export const URL_GET_FILE = `${URL_SOLICITUDES_PROVEEDORES}/GetFile`;
export const URL_BORRAR_DOCUMENTO_SOLICITUD = `${URL_SOLICITUDES_PROVEEDORES}/BorrarDocumentoSolicitud`;

// Términos y condiciones
export const URL_ACEPTAR_TERMINOS = `${URL_BASE}/api/PrivacidadEscotel/AceptarTerminos`;
